import React from 'react';
import type { ImageLayerProps } from '../ImageX.types';
import { PixelPerfectImage } from './ImageX.pixelPerfectImage';
import { ResponsiveImage } from './ImageX.responsiveImage';

export const ImageLayer: React.FC<ImageLayerProps> = ({
  className,
  id,
  imageInfo,
  defaultSrc,
  getPlaceholder,
  sources,
  isInFirstFold,
  objectFit,
  shouldUseResponsiveImages,
  imageLayerClass,
  cancelClip,
}) => {
  if (shouldUseResponsiveImages && sources?.length > 0) {
    return (
      <ResponsiveImage
        {...{
          sources,
          isInFirstFold,
          imageInfo,
          objectFit,
          className,
        }}
      />
    );
  } else {
    return (
      <PixelPerfectImage
        {...{
          id,
          imageInfo,
          defaultSrc,
          getPlaceholder,
          className,
          isInFirstFold,
          imageLayerClass,
          cancelClip,
        }}
      />
    );
  }
};
